import { createElementBlock as o, openBlock as t, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 22"
};
function l(s, e) {
  return t(), o("svg", n, [...e[0] || (e[0] = [
    r("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.714",
      d: "M7.929 16.356h5.143M10.5 16.356v-6H8.786M10.5 6.5a.429.429 0 1 1 0-.857M10.5 6.5a.429.429 0 1 0 0-.857"
    }, null, -1)
  ])]);
}
const i = { render: l };
export {
  i as default,
  l as render
};
